<template>
  <div id="home">
    <el-container>
      <div style="margin-top:40px;">
        <div class="main-banner">
          <div style="color:#ffffff;margin:0 100px;">
            <h1 style="padding:120px 0 30px 0">睿哲咨询</h1>
            <p style="font-weight:bold">人才发展&nbsp;&nbsp;&nbsp;组织发展</p>
            <p>领航人力资本  探索发展之道</p>
            <p>Pioneering HR Management</p>
            <p>Exploring Working Solution</p>
            <el-button type="danger" @click="gotoSearch" plain style="margin-top:40px;background-color:rgba(0,0,0,0);color:#fff;border:1px solid #ffffff;">开启在线测评</el-button>
            <span><el-button type="danger" @click="gotoCheck" plain style="margin-top:40px;margin-left:10px;background-color:rgba(0,0,0,0);color:#fff;border:1px solid #ffffff">开启薪酬查询</el-button></span>
            <span><el-button type="danger" @click="cooperater" plain style="margin-top:40px;margin-left:10px;background-color:rgba(0,0,0,0);color:#fff;border:1px solid #ffffff">加入HR服务商</el-button></span>
          </div>
        </div>
        <div class="main-container">
          <div class="intro">
            <div class="title">— 我们的业务 —</div>
            <div class="subtitle">快速了解睿哲咨询</div>
            <div style="text-align:center;margin:40px;">
              <el-row :gutter="40">
                <el-col :span="6">
                  <div  class="intro-item">
                    <img src="../assets/icons/about.png" alt="">
                    <div class="intro-des">咨询服务</div>
                    <div class="intro-subdes">睿哲咨询始终坚持高质量的研究和理性严谨的态度，高质量的数据和对科学的妥善运用始终居于我们所有解决方案的核心，我们的建议具有权威性，帮助客户做出最佳选择</div>
                  </div>                  
                </el-col>                
                <el-col :span="6">
                  <div  class="intro-item">
                    <img src="../assets/icons/income.png" alt="">
                    <div class="intro-des">培训发展</div>
                    <div class="intro-subdes">实践证明，个人修为、管理技能、领导思维三大模块的综合提升，与管理绩效的提升成正比，通过各个模块学习后，布置匹配的主题任务，通过在岗实践进行启发性思考</div>
                  </div>                  
                </el-col>
                <el-col :span="6">
                  <div  class="intro-item">
                    <img src="../assets/icons/analysis.png" alt="">
                    <div class="intro-des">测评工具</div>
                    <div class="intro-subdes">360度反馈、FIT智力测评、DISC测评、MBTI职业性格测试、九型人格测试。通过性格类型的觉察，你可以在最短时间内看到自己的思维模式、情绪模式以及行为模式的规律，帮助你认清自己</div>
                  </div>                  
                </el-col>
                <el-col :span="6">
                  <div  class="intro-item">
                    <img src="../assets/icons/partner.png" alt="">
                    <div class="intro-des">敬业度</div>
                    <div class="intro-subdes">企业的收入和盈利来源于为客户提供有价值的产品和服务，有价值的产品和服务又是企业内部员工创造的。同时，企业收入增长和盈利后，才有可能将更多的收益反馈给员工，实现双方共赢，持续发展</div>
                  </div>                  
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="product">
            <div class="title">— 产品特点 —</div>
            <div class="subtitle">根据企业不同需求采用不同的数据筛选算法</div>
            <div style="margin:40px 40px;">
              <el-row class="item">
                <el-col :span="12">
                  <el-row>
                    <el-col :span="4">
                      <img src="../assets/icons/data.png" class="icon" alt="">
                    </el-col>
                    <el-col :span="18">
                      <div class="des">轻度使用用户</div>                  
                      <div class="subdes">未注册用户可以免费查询薪酬一次</div>
                    </el-col>
                  </el-row>                  
                </el-col>
                <el-col :span="12">
                  <el-col :span="4">
                    <img src="../assets/icons/reg.png" class="icon" alt="">
                  </el-col>
                  <el-col :span="18">
                    <div class="des">中度使用用户</div>                  
                    <div class="subdes">注册用户可以免费查询薪酬五次，在线测评一次</div>
                  </el-col>
                </el-col>                
              </el-row>
              <el-row  class="item">                
                <el-col :span="12">
                  <el-col :span="4">
                    <img src="../assets/icons/buy.png" class="icon" alt="">
                  </el-col>
                  <el-col :span="18">
                    <div class="des">重度使用用户</div>                  
                    <div class="subdes">客户可以自定义查询条件。查看自己需要的薪酬口径，限定口径包年最低只需1000元</div>
                  </el-col>
                </el-col>
                <el-col :span="12">
                  <el-col :span="4">
                    <img src="../assets/icons/order.png" class="icon" alt="">
                  </el-col>
                  <el-col :span="18">
                    <div class="des">深度定制客户</div>                  
                    <div class="subdes">根据客户需求我们会介绍详细的定制方案，让客户花最少的钱做最多的事</div>
                  </el-col>
                </el-col>
              </el-row>
            </div>
          </div>      
          <div class="pay">
            <div class="title">— 其他业务 —</div>
            <div class="subtitle">其他收费业务帮助企业快速解决问题</div>
            <div class="other">
              <el-row>
                <el-col :span="12" class="item" style="padding-right:40px;">
                  <img src="../assets/images/aaaa.png" class="other-icon" alt="">
                  <div class="des">管理咨询</div>
                  <div class="subdes">睿哲咨询具有将高价值的管理咨询、切实可行的实施方法和持续改善的解决方案整合起来的领先能力，为客户提供高价值的完美咨询服务</div>
                </el-col>
                <el-col :span="1" class="item">
                  <div style="float:left;width: 1px;height: 80px; background: #dfdfdf;"></div> 
                </el-col>
                <el-col :span="11" class="item">
                  <img src="../assets/images/bbbb.png" class="other-icon" alt="">
                  <div class="des">企业内训</div>
                  <div class="subdes">我们秉承专注、专业主义，将我们的内训重心放在领导能力、HR技能、销售提升三个方向。</div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12" class="item" style="padding-right:40px;">
                  <img src="../assets/images/cccc.png" class="other-icon" alt="">
                  <div class="des">培训体系搭建</div>
                  <div class="subdes">我们借助CAD的三角模型，从源头找到人才培养发展的脉络，使企业培训体系更为精准，更适合企业本身的特点。</div>
                </el-col>
                <el-col :span="1" class="item">
                  <div style="float:left;width: 1px;height: 80px; background: #dfdfdf;"></div> 
                </el-col>
                <el-col :span="11" class="item">
                  <img src="../assets/images/dddd.png" class="other-icon" alt="">
                  <div class="des">测评工具</div>
                  <div class="subdes">360度反馈、FIT智力测评、DISC测评、MBTI职业性格测试、九型人格测试、满意度敬业度。</div>
                </el-col>
              </el-row>
            </div>
          </div>
          <!-- 
          <div class="pay">
            <div class="title">— 薪酬报告样本下载 —</div>
            <div class="subtitle">提前了解产品详细内容,帮助客户更好的选择适合自己的产品</div>
            <div class="other">
              <el-row :gutter="40" style="text-align:center">
                <el-col :span="6">
                  <img src="../assets/images/regular.png" class="sample-cover" alt="" @click="download('https://taizhicn-com.oss-cn-beijing.aliyuncs.com/download/太智联合薪酬调研报告--线上标准版.docx','线上报告标准版样本报告')">  
                </el-col>
                <el-col :span="6" >
                  <img src="../assets/images/sample-cover-professional.png" class="sample-cover" alt="" @click="download('https://taizhicn-com.oss-cn-beijing.aliyuncs.com/download/太智联合薪酬调研报告--线上专业版.docx','线上报告专业版样本报告')">                  
                </el-col>
                <el-col :span="6"  >
                  <img src="../assets/images/single.png" class="sample-cover" alt="" @click="download('https://taizhicn-com.oss-cn-beijing.aliyuncs.com/download/太智联合薪酬报告--线下岗位版.doc','薪酬报告单岗位样本报告')">                 
                </el-col>
                <el-col :span="6" >
                  <img src="../assets/images/all-industry.png" class="sample-cover" alt="" @click="download('https://taizhicn-com.oss-cn-beijing.aliyuncs.com/download/太智联合薪酬报告样本--线下行业版.doc','薪酬报告行业样本报告')">                
                </el-col>             
              </el-row>
            </div>
          </div>
          <div class="pay">
            <div class="title">— 资源下载 —</div>
            <div class="subtitle">太智联合最新发布的薪酬报告及工具</div>
            <div class="other">
              <el-row type="flex" align="middle" :gutter="40" style="text-align:center">
                <el-col :span="12">
                  <img src="../assets/images/datareport.png" class="sample-cover1" alt="" @click="download('https://taizhicn-com.oss-cn-beijing.aliyuncs.com/download/2019年度太智联合薪酬智库报告.pdf','2020智库报告')">  
                </el-col>
                <el-col :span="12" >
                  <img src="../assets/images/satisfaction.png" class="sample-cover1" alt="" @click="download('https://taizhicn-com.oss-cn-beijing.aliyuncs.com/download/（睿哲咨询）中国企业2019年度员工满意度敬业度调查报告.pdf','满意度敬业度报告')">                  
                </el-col>                     
              </el-row>
              <el-row :gutter="40" style="text-align:center;margin-top:60px;">                
                <el-col :span="12"  >
                  <img src="../assets/images/datacollection.png" class="sample-cover1" alt="" @click="download('https://taizhicn-com.oss-cn-beijing.aliyuncs.com/download/太智联合薪酬调研数据收集工具.xls','数据收集工具')">                 
                </el-col>
                <el-col :span="12" >
                  <img src="../assets/images/jobtest.png" class="sample-cover1" alt="" @click="download('https://taizhicn-com.oss-cn-beijing.aliyuncs.com/download/太智联合职位评估工具版本4.0.xls','职位评估工具')">                
                </el-col>             
              </el-row>
            </div>
          </div> -->
          <div class="message">
            <div class="title">— 留言咨询 —</div>
            <div class="subtitle">有任何问题都可以给我们留言，收到留言后第一时间会回复您</div>
            <div class="message-box">
              <el-row :gutter="40">                
                <el-col :span="16" :offset="4">
                  <el-row>
                    <el-col :span="14">
                      <el-input placeholder="您的电话号" v-model="tel"></el-input>
                    </el-col>
                    <el-col :span="9" :offset="1">
                      <el-button type="primary" @click="submit" :loading="loading" style="width:100%;">提交留言</el-button>
                    </el-col>
                  </el-row>
                  <el-row style="margin-top:20px;">
                    <el-col :span="24">
                      <el-input type="textarea" :rows="6" placeholder="您的咨询问题" v-model="problem"></el-input>
                    </el-col>              
                  </el-row>
                </el-col>                  
              </el-row>
            </div>
          </div>
        </div>
        <div v-show="show" style="position:absolute;z-index:999;top:200px;left:36%;width:300px;padding:40px;">
          <div style="padding:20px 0;font-size:16px">超值套餐包正式上线<br/>原价3000元，限时优惠只需500元即可获得</div>
          <div  @click="goDetail()" style="float:right;margin-top:20px"><div style="text-align:center;padding:6px 10px;background-color:red;color:#ffffff;width:100px;cursor:pointer;">了解详情</div></div>
        </div>
      </div>            
    </el-container>    
  </div>
</template>
<script>
import LOGO from "../assets/images/logo.png";
import helper from '../helper';
export default {
  name: "name",
  data() {
    return {
      logo: LOGO,
      tel:'',
      problem: "",
      loading:false,
      show:false,
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      //console.log(key, keyPath);
    },
    gotoSearch(){
      this.$router.push('/search')
      this.$store.dispatch('setCurrentIndexFun',"/search")
    },
    gotoCheck(){
      this.$router.push('/check');
      this.$store.dispatch('setCurrentIndexFun',"/check")
    },
    cooperater(){
      this.$router.push('/cooperater')
      this.$store.dispatch('setCurrentIndexFun',"/cooperater")
    },
    submit(){
      let tel = this.tel;
      let problem = this.problem;
      if(tel === '' || problem === ''){
        this.$notify({
          title:'提示',
          message:'请填写手机号和您的问题',
          type:'warning'
        })
        return
      }
      if(!(/^1[3456789]\d{9}$/.test(tel))){ 
        this.$notify({
          title:'提示',
          message:'手机号错误',
          type:'warning'
        })
        return
      }
      let _this = this;
      _this.loading = true;
      this.$http.post(
        helper.BASE_URL + '/api/home/index/liveMessage',        
        {tel:tel,problem:problem}
      )
      .then(function(response){
        //console.log(response.data);
        _this.loading = false;
        if(response.data.code === 1 ){
          _this.tel = '';
          _this.problem = '';          
          _this.$notify({
            title: '成功',
            message: response.data.msg,
            type: 'success'
          });
        }else{
          _this.$notify.error({
            title: '错误',
            message: response.data.msg
          });
        }
        
      })
      .catch(function (error) {
        //console.log(error);
      });
    },
    download(path,name){      
      var a = document.createElement('a');
      a.setAttribute('href', path);
      a.setAttribute('download', "测试样本报告");
      a.setAttribute('target', '_blank');
      a.setAttribute('id', 'startTelMedicine');
      // 防止反复添加
      if(document.getElementById('startTelMedicine')) {
        document.body.removeChild(document.getElementById('startTelMedicine'));
      }
      document.body.appendChild(a);
      a.click();
    }
  },
  mounted(){
    // this.$confirm('超值套餐包正式上线，原价3000元，限时优惠只需500元即可获得。服务包含：所有工具免费下载、100次薪酬查询、50次简版测评、任选三个培训课程观看权限。', '惊爆优惠', {
    //   confirmButtonText: '立即抢购',
    //   showCancelButton:false,
    //   type: 'warning'
    // }).then(() => {
    //   this.$router.push({name:'member-center',params:{activeIndex:'package'}})
    // }).catch(() => {
           
    // });
  }
};
</script>
<style scoped>
#home {
  background-color: #f4f4f4;
}
.el-main {
  padding: 0;
  margin: 0;
}
.main-container {
  margin: 0 100px;
}
.footer {
  background-color: #0bc8f4;
  line-height: 60px;
  text-align: center;
  color: #ffffff;
  font-size: 14px;
}
.main-banner {
  background-image: url(../assets/images/1.jpg);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center center;
  overflow: hidden;
  width: 100%;
  height: 100vh;  
}
.product,
.intro,
.pay,
.message {
  margin: 20px 0;
  padding-bottom: 20px;
  background-color: #ffffff;
  border-radius: 10px;
}
.title {
  font-size: 22px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: #333;
  line-height: 30px;
  letter-spacing: 1px;
  text-align: center;
  padding: 40px 0 0 0;
}
.subtitle {
  font-weight: 300;
  text-align: center;
  font-size: 14px;
  color: #939393;
  margin-top: 10px;
}
.des {
  font-size: 16px;
  font-family: PingFangSC-Medium;
  font-weight: bold;
  color: #333;
  line-height: 22px;
}
.subdes {
  margin-top: 6px;
  font-size: 14px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: #939393;
  line-height: 22px;
}
.intro-des {
  margin-top: 6px;
  font-size: 16px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: #ffffff;
  line-height: 22px;
}
.intro-subdes {
  margin-top: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: #ffffff;
  line-height: 20px;
  text-align:justify;
}
.icon {
  width: 60px;
  height: 60px;
}
.item {
  margin-bottom: 40px;
  padding: 20px;
}
.intro-item {
  background-color: #05A4C2;
  padding: 40px 20px;
  min-height: 280px;
  border-radius: 10px;
  transition: box-shadow 0.3s,margin-top 0.5s;
}
.intro-item:hover {  
  box-shadow: 0 4px 20px #05A4C2;
  margin-top: -10px;
}
.other {
  margin: 40px;
}
.other-icon {
  width: 100px;
  height: 100px;
  float: left;
  margin-right: 20px;
  border-radius: 50px;
  transition: transform .5s;
}
.other-icon:hover{
  transform:rotate(360deg);
}
.message-box {
  margin: 40px;
}
.sample-cover{
  width: 100%;
  border-radius: 10px;
  cursor: pointer;
}
.sample-cover1{
  width: 60%;
  border-radius: 10px;
  cursor: pointer;
}
.report-title{
  font-size: 16px;
  margin-top: 20px;
  font-family: PingFangSC-Medium;
  font-weight: bold;
  color: #333;
  line-height: 22px;
}
</style>

